'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const IndexTableCheckboxCell = ({
  contentId,
  selectionData,
  toggleSelection,
  isFolder = false,
  disabled = false
}) => {
  const {
    selectedFolders,
    selectedRows
  } = selectionData;
  const checkboxNotCorrectType = isFolder ? !selectedRows.isEmpty() : !selectedFolders.isEmpty();
  const checked = isFolder ? selectedFolders.has(contentId) : selectedRows.has(contentId);
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Checkbox, {
        "data-selenium-test": "index-row-checkbox",
        "aria-label": I18n.text('salesContentIndexUI.tableRow.checkbox'),
        checked: checked,
        disabled: disabled || checkboxNotCorrectType,
        onChange: toggleSelection
      })
    })
  });
};
IndexTableCheckboxCell.propTypes = {
  contentId: PropTypes.number,
  selectionData: PropTypes.object.isRequired,
  toggleSelection: PropTypes.func.isRequired,
  isFolder: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};
export default IndexTableCheckboxCell;